const dispatch = {
  dispatch$updateToken: (payload) => ({
    type: 'UPDATE_TOKEN',
    payload: payload
  }),
};

export default dispatch;
